import React from "react";

import { Button } from "../../../../components/Buttons/Button/Button";

import styles from "./styles.module.scss";

const TemplatesFooter = ({ onClickPrevState, onSave, onClickNextState }) => (
    <>
        <Button
            className={styles.btn}
            colorFirm={6}
            onClick={onClickPrevState}
        >
                Prev Step
        </Button>

        <Button
            className={styles.btn}
            colorFirm={5}
            onClick={onSave}
        >
                Save
        </Button>

        <Button
            className={styles.btn}
            colorFirm={6}
            onClick={onClickNextState}
        >
                Next Step
        </Button>
    </>
);

export default TemplatesFooter;
